'use strict';

angular.module('cdPay.components.inputHelper', []).component('cdInputHelper', {
  transclude: true,
  bindings: {
    cdDisabled: '<',
  },
  template: `
      <div class="animated fadeIn" style="margin-top: .75em;">
        <h5 class="ui header" ng-class="$ctrl.cdDisabled ? 'disabled' : 'red'" style="font-weight: 400;" ng-transclude></h5>
      </div>
    `,
});
